import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';

@Injectable({
  providedIn: 'root'
})
export class BookingService {

  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getAllBookings(body: any) {
    const link = this.apiUrl + ApiUrls.getBookings;
    return this.http.post<any>(link, body);
  }

  getBooking(id: any) {
    const link = this.baseUrl + ApiUrls.getBooking;
    return this.http.post<any>(link, { id });
  }

  deleteBooking(id: any) {
    const link = this.baseUrl + ApiUrls.deleteBooking;
    return this.http.post<any>(link, { id });
  }

  getBookingCount(body:any){
    const link = this.apiUrl + ApiUrls.getBookingCount;
    return this.http.post<any>(link, body);
  }
}
